// extracted by mini-css-extract-plugin
module.exports = {"headerPart":"HeaderPart_headerPart__DeFGz"};